import { Form, message, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clienteAxios from '../../../../../config/axios';
import classes from '../../../../pages/Balance/Balance.module.css';

const { Option } = Select;

const FormItemSelectFamilia = ({
    formInstance,
    formItemProps,
    selectProps,
    disabled,
    initialValue,
}) => {
    const [loading, setLoading] = useState(false);
    const [familias, setFamilias] = useState();
    const [formItemInitialValue, setFormItemInitialValue] = useState(null);

    useEffect(() => {
        obtenerFamilias();
    }, []);

    useEffect(() => {
        setFormItemInitialValue({ familiaId: initialValue });
    }, [initialValue]);

    useEffect(() => {
        formInstance.setFieldsValue(formItemInitialValue);
    }, [formItemInitialValue]);

    // Formulario - Obtener datos
    const obtenerFamilias = async () => {
        let arrFamilias = [{ id: '', name: 'Todas' }];
        setLoading(true);
        try {
            const respuesta = await clienteAxios.get('/families');
            arrFamilias = [...arrFamilias, ...respuesta?.data?.data?.families];
        } catch (error) {
            message.error(
                error.response?.data.message ||
                    'Hubo un problema al obtener la lista de franquicias',
            );
        }
        setLoading(false);
        setFormItemInitialValue((state) =>
            state?.familiaId ? { ...state } : { familiaId: arrFamilias[0].id },
        );
        setFamilias(arrFamilias);
    };

    return (
        <Form.Item
            name="familiaId"
            label="Familia"
            {...formItemProps}
            className={classes.filters}>
            <Select
                {...selectProps}
                disabled={disabled || loading}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                }>
                {familias &&
                    familias.map((item) => (
                        <Option key={item.id} value={item.id}>
                            {item.name}
                        </Option>
                    ))}
            </Select>
        </Form.Item>
    );
};

export default FormItemSelectFamilia;

FormItemSelectFamilia.propTypes = {
    formItemProps: PropTypes.any,
    selectProps: PropTypes.any,
    formInstance: PropTypes.instanceOf(Form),
    disabled: PropTypes.bool,
    initialValue: PropTypes.object,
};
